/** Mirrors `@zhichetech/models` apdm/out-reaching. */

/**
 * Which channels a campaign reaches a customer through, and in what order.
 */
export enum ApdmSendingPolicy {
  PrivateOnly = 'private_only',
  GroupOnly = 'group_only',
  /** Every account tries the private chat, then every account the group. */
  PrivateThenGroup = 'private_then_group',
  /** Every account tries the group, then every account the private chat. */
  GroupThenPrivate = 'group_then_private',
  /** Each account tries its private chat, then its group, before the next. */
  PrivateThenGroupPerAccount = 'private_then_group_per_account',
  /** Each account tries its group, then its private chat, before the next. */
  GroupThenPrivatePerAccount = 'group_then_private_per_account',
}

/** Mirror of backend `kApdmDefaultSendingPolicy`. */
export const kApdmDefaultSendingPolicy = ApdmSendingPolicy.PrivateOnly;

export function parseApdmSendingPolicy(
  value: unknown,
): ApdmSendingPolicy | null {
  return Object.values(ApdmSendingPolicy).includes(value as ApdmSendingPolicy)
    ? (value as ApdmSendingPolicy)
    : null;
}

/** Where a recipient was reached: mirror of backend `RpaChannelType`. */
export type ApdmReachedChannel = 'private_chat' | 'group_chat';
